import { ExpiredCardInfo, PaymentMethodDetails, PaymentMethodSelection } from '@components'

import React, { ReactElement } from 'react'

interface OrganizationPaymentMethodSelectionProps {
  paymentMethodDetails?: PaymentMethodDetails
  isCardExpired?: boolean
  isLoading?: boolean
  isSubscribed?: boolean
  onAddPaymentClick: () => void
  onUpdatePaymentClick?: () => void
}

export const OrganizationPaymentMethodSelection = ({
  paymentMethodDetails,
  isLoading,
  isSubscribed,
  onAddPaymentClick,
  onUpdatePaymentClick,
  isCardExpired,
}: OrganizationPaymentMethodSelectionProps): ReactElement => {
  return (
    <>
      <PaymentMethodSelection
        paymentMethodDetails={paymentMethodDetails}
        isLoading={isLoading}
        isSubscribed={isSubscribed}
        onAddPaymentClick={onAddPaymentClick}
      />
      {isCardExpired && <ExpiredCardInfo onUpdateCard={onUpdatePaymentClick} />}
    </>
  )
}
